import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import { useTranslation } from "react-i18next";

// @material-ui/icons
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

import { calculateValueCurrency } from "util/calculation.js";

const useStyles = makeStyles(menuStyle);

export default function BaseItem(props) {
  const {
    item,
    // language,
    currency,
    customStyle,
    // category,
    index,
    // openSweetAlert,
    addToCart,
    cart,
    updateCart,
    setShowPlacesWarning,
    availablePlaces,
    dateTimeSelected = null,
    eventSelected
  } = props;

  const classes = useStyles();

  // const { t } = useTranslation();

  let itemPrice = 0.00;

  const [quantity, setQuantity] = useState(0);

  useEffect(() => {
    /* QUESTO USEFFECT SERVE PER AGGIORNARE LA QUANTITA CORRETTA ANCHE NELLA LISTA */
    if (cart && item) {
      const copyCart = JSON.parse(JSON.stringify(cart));
      const findItem = copyCart.find(el => el.item && el.item.id === item.id);
      if (findItem && quantity !== findItem.quantity) {
        setQuantity(findItem.quantity);
      } else if (!findItem && quantity > 0) {
        setQuantity(0);
      }
    }
  }, [cart, item, quantity]);

  if (!Number.isNaN(Number(item.prezzo_articolo))) {
    if (!item.prezzo_articolo || item.prezzo_articolo === "0") {
      // if (item.add && item.add.length >= 0) {
      //   const populateAdd = item.add.map(el => {
      //     return restaurant.adjunct.find(element =>
      //       el._id ? element._id === el._id : element._id === el
      //     );
      //   });
      //   // const findEl = ingredientsCustom.find(element => element._id === el);
      //
      //   const findElSize = populateAdd.find(el => el.type === "SIZE");
      //   if (findElSize) {
      //     const nums = findElSize.add.map(el => el.price);
      //     let minValue = Math.min.apply(Math, nums);
      //     if (Number.isNaN(Number(minValue))) {
      //       minValue = 0;
      //     }
      //
      //     itemPrice = `${t("from")} ${calculateValueCurrency(
      //       Number(minValue),
      //       currency
      //     ).toFixed(2)} ${currency && currency.symbol ? currency.symbol : ""}`;
      //   }
      // }
    } else {
      itemPrice = `${
        currency && currency.symbol ? currency.symbol : ""
      } ${calculateValueCurrency(
        Number(item.prezzo_articolo),
        currency
      ).toFixed(2)}`;
    }
  } else {
    itemPrice = `${currency && currency.symbol ? currency.symbol : ""} 0.00`;
  }

  function onConfirm(item, quantity, ingredientC = {}, note, hg) {
    // setSelectedItem({});
    // setShowAddItem(false);
    /* ******************************
     DEVO FARE IL SORT DI INGREDIENT C
    ******************************* */
    // console.log("ON CONFIRM IS", {
    //   item,
    //   quantity,
    //   ingredientC,
    //   note,
    //   hg
    // });

    const ordered = {};
    const copyIngredientC = JSON.parse(JSON.stringify(ingredientC));
    let additionalKey = ``;
    Object.keys(copyIngredientC)
      .sort()
      .forEach(function(key) {
        ordered[key] = copyIngredientC[key];
        additionalKey += key;
      });
    if (ordered) {
      Object.keys(ordered).forEach(e => {
        function compare(a, b) {
          // Use toUpperCase() to ignore character casing
          const idA = a._id;
          const idB = b._id;

          let comparison = 0;
          if (idA > idB) {
            comparison = 1;
          } else if (idA < idB) {
            comparison = -1;
          }
          return comparison;
        }

        ordered[e].sort(compare);

        /* **********************************
        CREO ADDITIONALKEY PER SCOPRIRE SE LO
        STESSO ARTICOLO CON LE STESSE CORREZIONI
        DI UGUALE QUANTITÀ È GIÀ PRESENTE NEL
        CARRELLO --> SONO NECESSARI GLI ID PER
        OGNI ARTICOLO E PER OGNI CORREZIONE EFFETTUATA
        ************************************* */

        additionalKey += "";
      });
    }
    /* ******************************
     FINE SORT DI INGREDIENT C
    ******************************* */
    addToCart(item, quantity, ordered, additionalKey, note, hg);
  }

  function minusItem(item) {
    const copyCart = JSON.parse(JSON.stringify([].concat(cart)));
    // CERCO L'ELEMENTO CORRISPONDENTE E LO TOLGO DAL CARRELLO
    const findEl = copyCart.findIndex(el => {
      return el.item.id === item.id;
    });
    if (quantity === 1) {
      if (findEl >= 0) {
        copyCart.splice(findEl, 1);
      }
    } else if (copyCart[findEl]) {
      copyCart[findEl].quantity -= 1;
    }
    updateCart(copyCart);
  }

  const remainingPlaces = () => {
    const eventPlacesInCart = cart.filter(
      obj =>
        obj.item.schema_eventi.id === eventSelected.id &&
        moment(obj.dateTimeSelected).isSame(dateTimeSelected)
    );
    if (eventPlacesInCart.length > 0) {
      return (
        availablePlaces -
        eventPlacesInCart.reduce((t, obj) => t + obj.quantity, 0)
      );
    } else {
      return availablePlaces;
    }
  };

  // console.log("ITEM IS", { item });

  return (
    <GridItem xs={12} sm={12} md={12} lg={6} key={item && item.id}>
      <Card key={item && item.id} className={classes.containerMenu}>
        <div>
          {/* {item.image_url ? (
            <img
              alt={`image-${item && item.id}`}
              src={item.image_url}
              // style={{ height: "170px", width: "170px" }}
              className={classes.image}
              // togliere width all'immagine per non farla quadrata e slabbrata
            />
          ) : null} */}
          <div
            className={classes.containerInfo}
            style={!item.image_url ? { width: "100%", minHeight: "20px" } : {}}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex"
              }}
            >
              {item && item.id && item.nome_articolo ? (
                <h3
                  className={classes.dishName}
                  style={{
                    maxWidth: `calc(100% - 100px)`,
                    width: "100%"
                  }}
                >
                  {item.nome_articolo ? item.nome_articolo.toUpperCase() : ""}
                </h3>
              ) : (
                ""
              )}
            </div>
            {item && item.venditore_articolo ? (
              // DISH DESCRIPTION
              <div
                className={classes.description.concat(" description")}
                style={{
                  fontStyle: "italic",
                  marginTop: "3px"
                }}
              >
                {item.venditore_articolo}
              </div>
            ) : null}
            {item && item.giacenza_articolo ? (
              // DISH DESCRIPTION
              <div
                className={classes.description.concat(" description")}
                style={{
                  fontStyle: "italic",
                  marginTop: "3px"
                }}
              >
                n. {item.giacenza_articolo}
              </div>
            ) : null}
            <div>
              <div
                className={classes.containerElement}
                style={
                  !item.image_url
                    ? {
                        // width: `calc(100%  - 30px)`,
                        // width: "calc(100% - 30px)",
                        minHeight: "20px",
                        width: "100%"
                      }
                    : {}
                }
              >
                <div className={classes.containerLeft}>
                  <div className={classes.priceText} style={{ float: "right" }}>
                    {itemPrice}
                  </div>
                </div>
                <div className={classes.containerRight}>
                  <div>
                    {/* <Button
                      round
                      size="sm"
                      color="warning"
                      // className={classes.buttonBig}
                      // color="info"
                      onClick={() => {
                        // addToCart(item);
                        openSweetAlert(item, category, index, item.timetable);
                      }}
                      style={{
                        backgroundColor: customStyle.buttonCart
                      }}
                    >
                      <span className={classes.buttonSmallText}>
                        {t("cart.add")}
                      </span>
                    </Button> */}
                    <Button
                      round
                      size="sm"
                      color="transparent"
                      className={classes.buttonSmall}
                      onClick={() => {
                        // updateQuantity("minus");
                        const newQuantity = quantity - 1;
                        setQuantity(newQuantity);
                        minusItem(item, index);
                      }}
                      style={{
                        borderColor: customStyle.buttonAction,
                        color: customStyle.buttonAction
                      }}
                      disabled={quantity === 0}
                    >
                      <span
                        className={classes.buttonText}
                        style={{ color: customStyle.buttonAction }}
                      >
                        -
                      </span>
                    </Button>
                    <span
                      className={classes.priceText}
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "10px"
                      }}
                    >
                      {quantity}
                    </span>
                    <Button
                      round
                      size="sm"
                      color="transparent"
                      className={classes.buttonSmall}
                      // color="info"
                      onClick={() => {
                        if (remainingPlaces() > 0) {
                          const newQuantity = quantity + 1;
                          setQuantity(newQuantity);
                          onConfirm(item, 1);
                          // updateQuantity("plus");
                        } else {
                          setShowPlacesWarning(true);
                        }
                      }}
                      // disabled={isSize}
                      style={{
                        borderColor: customStyle.buttonAction,
                        color: customStyle.buttonAction
                      }}
                    >
                      <span
                        className={classes.buttonText}
                        style={{ color: customStyle.buttonAction }}
                      >
                        +
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </GridItem>
  );
}

BaseItem.propTypes = {
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string
  }).isRequired,
  // language: PropTypes.string.isRequired,
  // category: PropTypes.object,
  customStyle: PropTypes.object,
  index: PropTypes.number.isRequired,
  item: PropTypes.objectOf(PropTypes.any),
  // openSweetAlert: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  updateCart: PropTypes.func.isRequired,
  cart: PropTypes.arrayOf(PropTypes.any).isRequired
};

BaseItem.defaultProps = {
  // category: null,
  customStyle: {},
  item: null
};
